import { DataTable } from "@/components/data-table";
import { Form } from "@/components/form";
import { formatNumber, formatString } from "@/shared/formats";
import { Stack, Typography } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import { Articulo } from "@/shared/types/articulo";
import useMonetizacion from "@/features/monetizacion/hooks/use-monetizacion";

interface CompraArticuloListProps {
    items: { articulo?: Articulo, articuloId: string, costoUnitario: number, cantidad: number }[],
    remove?: (index: number) => void,
}

export default function CompraArticuloList({
    items,
    remove = () => { }
}: CompraArticuloListProps) {
    const { monedaBase } = useMonetizacion();

    return <Stack gap={1} flex={1} minHeight={"350px"}>
        <Stack direction={"row"} alignItems={"center"}>
            <Typography variant="h6" flex={"1 1 auto"}>Artículos</Typography>
            <Form.CheckBox name="credito" label="Crédito" size="small" />
        </Stack>
        <DataTable flex={1}>
            <DataTable.Content
                fit="flex"
                rows={items}
                columns={[
                    { header: "#", render: (_, index) => formatNumber(index + 1), width: "auto" },
                    { header: "Nombre", render: row => formatString(row.articulo?.nombre) },
                    { header: `Costo (${monedaBase.simbolo})`, render: row => formatNumber(row.costoUnitario), align: "right" },
                    { header: "Cantidad (uds.)", render: row => formatNumber(row.cantidad), align: "right" },
                    { header: `Subtotal (${monedaBase.simbolo})`, render: row => formatNumber(row.cantidad * row.costoUnitario), align: "right" },
                    {
                        header: "", render: (_, index) => <Form.IconButton size="small" onClick={() => remove(index)}>
                            <ClearIcon fontSize="small" />
                        </Form.IconButton>, width: "auto", align: "center"
                    }
                ]}
                footers={[
                    { render: () => <Typography variant="subtitle1">Total</Typography>, span: 3 },
                    { render: () => <Typography variant="subtitle2">{formatNumber(items.reduce((p, v) => p + v.cantidad, 0))}</Typography>, align: "right" },
                    { render: () => <Typography variant="subtitle2">{formatNumber(items.reduce((p, v) => p + v.costoUnitario * v.cantidad, 0))}</Typography>, align: "right" },
                    { render: () => <></> }
                ]}
            />
        </DataTable>
    </Stack>
}